<template>
    <pulse-loader color="#4f46e6" size="15px"></pulse-loader>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
    components: {
        PulseLoader
    }
}
</script>
